import AbstractManageable from './abstract-manageable';

export default class User extends AbstractManageable {
	/**
	 * 
	 * @param {Number} id 
	 * @param {String} username 
	 * @param {String} email 
	 * @param {String} firstName 
	 * @param {String} lastName 
	 * @param {String} phone1 
	 * @param {String} phone2 
	 * @param {Boolean} enabled 
	 * @param {Array} groups 
	 * @param {Array} roles 
	 * @param {User} creator 
	 * @param {Date} createdAt 
	 * @param {User} updater 
	 * @param {Date} updatedAt 
	 */
	constructor(id, username, email, firstName, lastName, phone1, phone2, enabled, groups, roles, creator, createdAt, updater, updatedAt) {
		super(creator, createdAt, updater, updatedAt);
		this.email = email;
		this.enabled = enabled;
		this.firstName = firstName;
		this.groups = groups;
		this.id = id;
		this.lastName = lastName;
		this.phone1 = phone1;
		this.phone2 = phone2;
		this.roles = roles;
		this.username = username;
	}

	static createFromJson = (json) => {
		if (!json) return null;
		
		const id = json.id;
		const username = json.username;
		const email = json.email;
		const firstName = json.firstName;
		const lastName = json.lastName;
		const phone1 = json.phone1;
		const phone2 = json.phone2;
		const enabled = json.enabled;
		const groups = json.groups;
		const roles = json.roles;
		const creator = User.createFromJson(json.creator);
		const createdAt = new Date(json.createdAt);
		const updater = User.createFromJson(json.updater);
		const updatedAt = new Date(json.updatedAt);

		return new User(id, username, email, firstName, lastName, phone1, phone2, enabled, groups, roles, creator, createdAt, updater, updatedAt);
	}
}


// WEBPACK FOOTER //
// ./src/model/user.js